<template>
  <div class="home-box">
    <div class="share-content">
      <img class="bgImg" src="@/assets/shareUserCollection_bg.png" alt="">
      <div class="share-content-form">
        <div class="content">
          <div class="share-form-lable">您的姓名：</div>
          <input type="text" class="share-form-input" v-model="name" placeholder="请输入姓名">
        </div>
        <div class="content flex jc-c ai-c">
          <div class="share-form-lable">手机号*：</div>
          <input type="text" class="share-form-input" v-model="phone" placeholder="请输入电话" inputmode="tel">
        </div>
        <div class="content flex jc-c ai-c">
          <div class="share-form-lable">邮箱*：</div>
          <input type="text" class="share-form-input" v-model="email" placeholder="请输入邮箱" inputmode="email">
        </div>
        <div class="content flex jc-c ai-c">
          <div class="share-form-lable">公司全称：</div>
          <input type="text" class="share-form-input" v-model="companyName" placeholder="请输入公司全称">
        </div>
        <div class="content flex jc-c ai-c">
          <div class="share-form-lable">公司品牌：</div>
          <input type="text" class="share-form-input" v-model="companyBrand" placeholder="请输入公司品牌">
        </div>
        <div class="content flex jc-c ai-c">
          <div class="share-form-lable">所在行业：</div>
          <input type="text" class="share-form-input" v-model="companyIndustry" placeholder="请输入所在行业">
        </div>
        <div class="content flex jc-c ai-c">
          <div class="share-form-lable">所在部门：</div>
          <input type="text" class="share-form-input" v-model="companyDepartment" placeholder="请输入所在部门">
        </div>
        <div class="content flex jc-c ai-fa">
          <div class="share-form-lable">您的需求：</div>
          <textarea cols="30" rows="5" class="share-form-input-text textareaStyle" v-model="dataRequirements" placeholder="请输入您的需求"></textarea>
        </div>
        <div class="share-content-submit" @click="submit">提交</div>
        <div class="share-content-foot">
          <div class="footLable">北京星图数网科技有限公司</div>
          <div class="footLable">电话：400-066-9026</div>
          <div class="footLable">邮箱：info@syntun.com</div>
          <div class="footLable">网址：www.syntun.com.cn</div>
          <div class="footLable">北京市北京经济开发区科创十三街锋创科技园8号楼5层</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'
import axios from 'axios'
export default {
  name: 'officialAccount',
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      companyName: '',
      companyIndustry: '',
      dataRequirements: '',
      companyBrand: '',
      companyDepartment: '',
      isSuccess: false,
    }
  },
  components: { Toast },
  mounted() {},
  computed: {},
  methods: {
    //提交表单
    submit() {
      if (this.isSuccess) return
      // if (this.name == '') {
      //   Toast.fail({
      //     message: '姓名不能为空',
      //     className: 'toastStyle',
      //   })
      //   return
      // }
      if (this.phone == '') {
        Toast.fail({
          message: '电话不能为空',
          className: 'toastStyle',
        })
        return
      }
      if (this.email == '') {
        Toast.fail({
          message: '邮箱不能为空',
          className: 'toastStyle',
        })
        return
      }
      // if (this.companyName == '') {
      //   Toast.fail({
      //     message: '公司全称不能为空',
      //     className: 'toastStyle',
      //   })
      //   return
      // }
      // if (this.companyIndustry == '') {
      //   Toast.fail({
      //     message: '公司行业不能为空',
      //     className: 'toastStyle',
      //   })
      //   return
      // }
      //判断手机号格式是否正确
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast.fail({
          message: '请输入正确的手机号',
          className: 'toastStyle',
        })
        return
      }
      //判断邮箱格式是否正确
      if (
        this.email != '' &&
        !/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(this.email)
      ) {
        Toast.fail({
          message: '请输入正确的邮箱',
          className: 'toastStyle',
        })
        return
      }
      //  https://infinitytest.syntun.com/data/insertDataRequirements
      //axios,post请求
      const test = 'http://192.168.0.72:8905/data/insertRequirements'
      const prod = 'https://infinitytest.syntun.cn/data/insertRequirements'
      axios
        .post(prod, {
          name: this.name,
          phone: this.phone,
          email: this.email,
          companyName: this.companyName,
          companyIndustry: this.companyIndustry,
          dataRequirements: this.dataRequirements,
          companyBrand: this.companyBrand, // 公司品牌
          companyDepartment: this.companyDepartment, // 公司部门
        })
        .then((res) => {
          if (res.data.code == 200) {
            Toast.success({
              message: '提交成功！',
              className: 'toastStyle toastBg',
              duration: 0,
              overlay: true,
            })
            this.isSuccess = true
          } else {
            Toast.fail({
              message: '提交失败，请联系管理员！',
              className: 'toastStyle',
            })
          }
        })
        .catch((err) => {
          Toast.fail({
            message: '提交失败，请联系管理员！',
            className: 'toastStyle',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.home-box {
  font-family: 'Source Han Sans CN';
  display: flex;
  align-items: center;
  justify-content: center;
  background: #99ccff;
  .bgImg {
    width: 100%;
    height: auto;
    position: relative;
    z-index: 0;
  }
}
.share-content {
  width: 100%;
  height: auto;
  position: relative;
}
.share-content-form {
  width: 100%;
  position: absolute;
  top: 12%;
  z-index: 1;
  .content {
    margin-bottom: 20px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.share-form-input {
  width: 240px;
  height: 30px;
  border: 2px solid #7f5f44;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0);
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #977f65;
  padding: 0 20px;
  box-sizing: border-box;
}
.share-form-input-text {
  width: 240px;
  border: 2px solid #7f5f44;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0);
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #977f65;
  padding: 0 20px;
  box-sizing: border-box;
  &::placeholder {
    line-height: 146px;
  }
}
.textareaStyle {
  height: auto;
}
.share-form-lable {
  white-space: nowrap;
  min-width: 100px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #5e5135;
  text-align: left;
}
.share-content-submit {
  width: 180px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 10px;
  background: url('~@/assets/officialAccount/btn.png') no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  margin: 0 auto;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
}
.share-content-foot {
  margin-top: 20px;
  padding: 16px;
  .footLable {
    text-align: left;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #5e5135;
    line-height: 50px;
  }
}
@media (min-width: 751px) {
  .share-content {
    width: 750px;
    height: auto;
  }
  .share-content-form {
    width: 750px;
    top: 11%;
  }
  .share-form-lable {
    width: 160px;
    font-size: 28px;
  }
  .share-form-input {
    width: 480px;
    height: 50px;
    font-size: 22px;
  }
  .share-form-input-text {
    width: 480px;
    font-size: 22px;
  }
  .share-content-form .content {
    margin-bottom: 40px;
    justify-content: center;
  }
  .share-content-submit {
    width: 200px;
    height: 80px;
    line-height: 80px;
    font-size: 30px;
  }
  .share-content-foot {
    padding: 16px 0 0 80px;
  }
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #977f65;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #977f65;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #977f65;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #977f65;
}
</style>